import { useState } from 'react';

import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Typography,
} from '@mui/material';
import { Formik } from 'formik';

import { FileUploadDropDown } from 'src/components/FormikComponents';
import { useAddPartnerContext } from 'src/contexts/AddPartnerProvider';

import { Card } from '../components';

export const Step5: React.FC = () => {
    const [isContractSigned, setIsContractSigned] = useState(false);
    const [, setIsContractSignedUploaded] = useState(false);
    const { application, addPartner, handleBack, activeStep } = useAddPartnerContext();

    const contractDocTypes = [
        {
            key: 'Signed_Contract',
            value: 'Signed Contact',
        },
    ];

    return (
        <Box display="flex" flexDirection="column" gap="24px">
            <Formik
                initialValues={{
                    isPartnerContractSigned: !!application?.partnerContractSignedAt,
                    contract: application?.contract || null,
                }}
                // disable if contract is not uploaded
                onSubmit={async (values) => {
                    const contract = (values.contract as any)?.locationUrl ?? '';
                    await addPartner(
                        {
                            isPartnerContractSigned: values?.isPartnerContractSigned,
                            contract,
                            step: 5,
                        },
                        activeStep
                    );
                }}
            >
                {(formik) => {
                    if (formik?.values?.contract) {
                        setIsContractSignedUploaded(true);
                        setIsContractSigned(true);
                    } else {
                        setIsContractSigned(false);
                    }
                    const acceptedFilesToUpload = {
                        'text/pdf': ['.pdf', '.PDF', '.Pdf', '.pDf', '.pdF'],
                        'image/jpeg': [
                            '.jpeg',
                            '.jpg',
                            '.png',
                            '.JPEG',
                            '.JPG',
                            '.PNG',
                            '.Jpeg',
                            '.Jpg',
                            '.png',
                            '.jPeg',
                            '.jPg',
                            '.Png',
                            '.jpEg',
                            '.jpg',
                            '.pNg',
                            '.jpeG',
                            '.jpG',
                            '.pnG',
                        ],
                    };
                    return (
                        <>
                            <Card heading="Contract Generation">
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    marginBottom="24px"
                                    maxWidth="50%"
                                >
                                    <Typography fontSize="16px" color="#575757" marginRight="21px">
                                        Has the Partner contract been signed
                                    </Typography>

                                    <FormControl component="fieldset">
                                        <RadioGroup
                                            aria-labelledby="service-billed-radio-buttons"
                                            name="service-billed-radio-group"
                                            row
                                            defaultValue={formik.values.isPartnerContractSigned}
                                        >
                                            <FormControlLabel
                                                value={true}
                                                control={<Radio sx={{ color: '#F39E4E' }} />}
                                                label="Yes"
                                                onClick={() =>
                                                    formik.setFieldValue(
                                                        'isPartnerContractSigned',
                                                        true
                                                    )
                                                }
                                                data-testid={'isPartnerContractSigned-radio-true'}
                                            />
                                            <FormControlLabel
                                                value={false}
                                                control={<Radio sx={{ color: '#F39E4E' }} />}
                                                label="No"
                                                onClick={() => {
                                                    formik.setFieldValue(
                                                        'isPartnerContractSigned',
                                                        false
                                                    );
                                                    setIsContractSignedUploaded(false);
                                                    setIsContractSigned(false);
                                                }}
                                                data-testid={'isPartnerContractSigned-radio-false'}
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Box>

                                <Box maxWidth="50%">
                                    {formik.values.isPartnerContractSigned ? (
                                        <FileUploadDropDown
                                            name="contract"
                                            fileTypes={contractDocTypes.map(({ key, value }) => ({
                                                value,
                                                label: key,
                                            }))}
                                            acceptedFileTypes={acceptedFilesToUpload}
                                            label="Signed Contract"
                                        />
                                    ) : null}
                                </Box>
                            </Card>

                            <Box display="flex" justifyContent="flex-end">
                                <Button
                                    sx={{
                                        alignSelf: 'end',
                                        marginTop: '24px',
                                        bgcolor: '#1D1D1B',
                                        color: 'white',
                                        ':hover': {
                                            bgcolor: 'rgba(0, 0, 0, 0.7)',
                                        },
                                        ':disabled': {
                                            bgcolor: '#686867',
                                        },
                                    }}
                                    disabled={!handleBack}
                                    onClick={handleBack}
                                    variant="main"
                                    data-testid={'add-partner-back-button'}
                                >
                                    Back
                                </Button>
                                <Button
                                    sx={{
                                        alignSelf: 'end',
                                        marginTop: '24px',
                                        marginLeft: '16px',
                                        bgcolor: '#1D1D1B',
                                        color: 'white',
                                        ':hover': {
                                            bgcolor: 'rgba(0, 0, 0, 0.7)',
                                        },
                                        ':disabled': {
                                            bgcolor: '#686867',
                                        },
                                    }}
                                    type="submit"
                                    onClick={() => formik.handleSubmit()}
                                    variant="main"
                                    disabled={!isContractSigned}
                                    data-testid={'add-partner-submit-button'}
                                >
                                    Save
                                </Button>
                            </Box>
                        </>
                    );
                }}
            </Formik>
        </Box>
    );
};
